const tournamentApplicationStatuses = {
  new: {
    id: 1,
    title: 'new',
    name: 'Еще не подтвердили участие'
  },
  approved: {
    id: 2,
    title: 'approved',
    name: 'Подтвердили участие'
  },
  rejected: {
    id: 3,
    title: 'rejected',
    name: 'Отказано в регистрации'
  },
  canceled: {
    id: 4,
    title: 'canceled',
    name: 'Отменили заявку'
  }
};

export default tournamentApplicationStatuses;


// WEBPACK FOOTER //
// ./src/components/tournamentApplicationStatuses.js